import { render, staticRenderFns } from "./IconCompMedal.vue?vue&type=template&id=e904be82"
import script from "./IconCompMedal.vue?vue&type=script&lang=js"
export * from "./IconCompMedal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports